import api from './api';

/**
 * Playlists Service - Handles all playlist-related API calls
 */
const playlistsService = {
  /**
   * Get all public playlists
   * @returns {Promise} Resolves to a list of playlists
   */
  getAll: async () => {
    try {
      const response = await api.get('api/public/playlists');
      return response.data;
    } catch (error) {
      console.error('Error fetching playlists:', error);
      throw error;
    }
  },

  /**
   * Get a specific playlist by ID
   * @param {string} id - Playlist ID
   * @returns {Promise} Resolves to playlist details
   */
  get: async (id) => {
    try {
      const response = await api.get(`api/public/playlists/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching playlist ${id}:`, error);
      throw error;
    }
  },

  /**
   * Submit a song to a playlist
   * @param {Object} data - Submission data
   * @param {string} data.title - Title of the playlist
   * @param {string} data.distribution - ID of the song/distribution
   * @param {string} data.pitch - Pitch text explaining why the song should be added
   * @returns {Promise} Resolves to submission result
   */
  submitSong: async (data) => {
    try {
      const response = await api.post('api/playlisting/submit', {
        title: data.title,
        song: data.song,
        song_index: data.song_index,
        distribution: data.distribution,
        pitch: data.pitch,
      });
      return response.data;
    } catch (error) {
      console.error('Error submitting song to playlist:', error);
      throw error;
    }
  },
};

export default playlistsService;